/**
 * Created by AlexanderC on 3/7/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _Exception = require('../../Exception/Exception');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let AbstractDriver = exports.AbstractDriver = function (_Core$OOP$Interface) {
  _inherits(AbstractDriver, _Core$OOP$Interface);

  function AbstractDriver() {
    _classCallCheck(this, AbstractDriver);

    var _this = _possibleConstructorReturn(this, (AbstractDriver.__proto__ || Object.getPrototypeOf(AbstractDriver)).call(this, ['_load']));

    _this._onLoaded = () => {};
    _this._onFail = () => {};
    return _this;
  }

  /**
   * @param {AbstractDriver|*} mainDriver
   * @returns {AbstractDriver|FsDriver|HttpDriver|KernelDriver|ComplexDriver|*}
   */


  _createClass(AbstractDriver, [{
    key: 'inherit',
    value: function inherit(mainDriver) {
      this.onLoadedCb(mainDriver.onLoaded);
      this.onFailCb(mainDriver.onFail);

      return this;
    }

    /**
     * @param {*} args
     * @returns {AbstractDriver|FsDriver|HttpDriver|KernelDriver|ComplexDriver|*}
     *
     * @todo: Add Sandbox functionality?
     */

  }, {
    key: 'load',
    value: function load() {
      this._load.apply(this, arguments);

      return this;
    }

    /**
     * @param {String} rawConfig
     * @returns {AbstractDriver}
     */

  }, {
    key: 'loadedJson',
    value: function loadedJson(rawConfig) {
      let config = null;

      try {
        config = JSON.parse(rawConfig);
      } catch (error) {
        return this.fail(`Failed to parse config from ${this._endpoint}: ${error}`);
      }

      return this.loaded(config);
    }

    /**
     * @param {*} config
     * @returns {AbstractDriver}
     */

  }, {
    key: 'loaded',
    value: function loaded(config) {
      this._onLoaded(config);

      return this;
    }

    /**
     * @param {Error|*} error
     * @returns {AbstractDriver}
     */

  }, {
    key: 'fail',
    value: function fail(error) {
      this._onFail(typeof error === 'string' ? new _Exception.Exception(error) : error);

      return this;
    }

    /**
     * @returns {Function|*}
     */

  }, {
    key: 'onLoadedCb',


    /**
     * @param {Function} cb
     * @returns {AbstractDriver}
     */
    value: function onLoadedCb(cb) {
      this._onLoaded = cb;

      return this;
    }

    /**
     * @returns {Function|*}
     */

  }, {
    key: 'onFailCb',


    /**
     * @param {Function} cb
     * @returns {AbstractDriver}
     */
    value: function onFailCb(cb) {
      this._onFail = cb;

      return this;
    }
  }, {
    key: 'onLoaded',
    get: function get() {
      return this._onLoaded;
    }
  }, {
    key: 'onFail',
    get: function get() {
      return this._onFail;
    }
  }]);

  return AbstractDriver;
}(_deepCore2.default.OOP.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Config/Driver/AbstractDriver.js
// module id = 34
// module chunks = 0